import { OrganizationChartNode } from 'models';
import { Box, Card, CardContent, CardHeader, CardMedia, Grid, MenuItem, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { PartnerPlacement } from 'enums';
import { Add } from '@mui/icons-material';
import './PartnerNode.scss';
import { PartnerNodeProps } from './PartnerNodeProps';
import { RegisterUserForm, OrgChartConnection } from 'components';
import { useAuth } from 'hooks';

export const PartnerNode = ({ setPartnerId, nodes }: PartnerNodeProps) => {
	const [open, setOpen] = useState(false);
	const { currentUserId } = useAuth();
	const [{ placement, placementPartnerId }, setEnrollmentDialogProps] = useState({
		placement: PartnerPlacement['Partner Placement'],
		placementPartnerId: 0
	})
	const levelColor = '#1976d2';
	const openEnrollDialog = (item: OrganizationChartNode) => {
		setEnrollmentDialogProps({
			placementPartnerId: item?.placementPartnerId ?? 0,
			placement: item?.placement ?? 0,
		});
		setOpen(true);
	};
	const handleSetNode = async (id: number) => {
		if (nodes.length > 1 || id === currentUserId) setPartnerId(id);
	};

	return (
		<>
			<Grid container p={2}>
				{nodes
					?.sort((a, b) => (a.placement < b.placement ? -1 : 1))
					?.map((item, index) => (
						<Grid item xs={12 / nodes.length} key={index} textAlign={'center'}>
							{item?.id === -1 ? (
								<>
									<MenuItem key={index} onClick={() => openEnrollDialog(item)} style={{ display: 'flex', justifyContent: 'center', zIndex: 1, textAlign: 'center' }}>
										<Card>
											<CardContent>
												<Grid container p={1} alignItems={'center'} className='Grid-CardMedia-img-container' sx={{minWidth:'50px', minHeight:'50px'}}>
													<Grid item xs={12} justifySelf={'center'}>
														<Add />
													</Grid>
												</Grid>
											</CardContent>
											<CardHeader style={{ backgroundColor: levelColor }}></CardHeader>
										</Card>
										<OrgChartConnection nodeCount={item?.children?.length} />
									</MenuItem>
								</>
							) : (
								<>
									<MenuItem
										key={index}
										onClick={() => {
											handleSetNode(item.id);
										}}
										style={{ display: 'flex', justifyContent: 'center', zIndex: 1, textAlign: 'center', minWidth: '180px' }}
									>
										<Card>
											<CardContent>
												<Grid container alignItems={'center'}>
													<Grid item xs={12}>
														<Typography variant={'body2'}>
															{item.firstName} {item.lastName}
														</Typography>
														{item.mentor && (
															<Typography variant={'body2'}>
																M: {item.mentor?.firstName} {item.mentor?.lastName}
															</Typography>)
														}
													</Grid>
													<Grid item xs={12} textAlign={'center'} className='Grid-CardMedia-img-container'>
														<CardMedia component={'img'} src={item.imageUrl ?? '/no-profile-image.jpg'} />
													</Grid>
												</Grid>
											</CardContent>
											<CardHeader style={{ backgroundColor: levelColor }}></CardHeader>
										</Card>
										<OrgChartConnection nodeCount={item?.children?.length} />
									</MenuItem>
								</>
							)}
							<PartnerNode nodes={item.children} setPartnerId={setPartnerId} />
						</Grid>
					))}
			</Grid>
			<Box component={Paper}>
				<RegisterUserForm open={open} setOpen={setOpen} placement={placement} placementPartnerId={placementPartnerId} />
			</Box>
		</>
	)
}